import { useCallback, useRef } from "react";

/** Increment on each new async work unit; ignore stale completions when id !== current. */
export function useLatestRequestId() {
  const ref = useRef(0);
  const next = useCallback(() => ++ref.current, []);
  const isCurrent = useCallback((id: number) => id === ref.current, []);
  return { next, isCurrent };
}
